const errorMessages = new Map<string, string>([
  ['The Action is the same as previous', 'Дія акту така ж, як і попередня'],
  [
    "Device Check Action can't be first",
    'Дія перевірки пристрою не може бути першою',
  ],
  [
    'CommercialOperationAcceptance should be the only first Act type',
    'Вид акту - Приймання в комерційну експлуатацію має бути першим типом акта',
  ],
  ['Invalid Modem ActionId', 'Недійсний ID дії модему'],
  [
    'The Modem Action is the same as previous',
    'Дія модема така ж, як і в попередньому',
  ],
  ['Metering Point is Liquidated', 'Точка вимірювання ліквідована'],
]);

type ErrorLikeType = {
  errorMessage: string;
  propertyName: string;
};

const getTranslatedErrorMessage = ({ errorMessage }: ErrorLikeType) =>
  errorMessages.get(errorMessage) ?? errorMessage;

type GetErrorMessagesType = (
  error: any,
  defaultErrorMessage?: string,
) => string | string[];

export const getErrorMessages: GetErrorMessagesType = (
  error,
  defaultErrorMessage = 'Помилка створення Акту',
) => {
  if (error.status === 400) {
    const errors = error?.data?.errors as ErrorLikeType[];

    if (errors) {
      return errors.map(getTranslatedErrorMessage);
    }
  }

  return defaultErrorMessage;
};
